import { createAction, props } from '@ngrx/store';
import { CaseState } from '../../interfaces/interfaces';

export const saveCaseInformations = createAction(
  '[Case] Save Case Informations Case',
  props<{ caseObj: any }>()
);
export const saveCaseInformationsSuccess = createAction(
  '[Case] Save Case Informations Case Success',
  props<{ data: any }>()
);
export const saveCaseInformationsFailure = createAction(
  '[Case] Save Case Informations Case Failure',
  props<{ error: string }>()
);

export const setCaseInformationSuccess = (
  state: CaseState,
  { data }: { data: any }
) => {
  //eğerki fiyat tipi değiştiği için hizmetler silindi ise bu alanları sıfırlamamız lazım
  const resetIfDeleted =
    data?.isServiceDeleted === true
      ? {
          serviceInformations: null,
          numberOfServices: null,
          provisionNo: null,
          provisionInstitution: null,
          provisionDescription: null,
          totalPrice: null,
          lastPrice: null,
          totalProvisionPrice: null,
          totalDiscountPrice: null,
          bottomDiscountPrice: null,
        }
      : {};

  return {
    ...state,
    case: {
      ...state.case,
      ...resetIfDeleted, // önce reset'leri uygula
      caseInformations: {
        assuranceType: data?.caseInformations?.assuranceType?.valueObject?.id
          ?.value
          ? {
              label:
                data?.caseInformations?.assuranceType?.valueObject?.name?.value,
              value:
                data?.caseInformations?.assuranceType?.valueObject?.id?.value,
            }
          : null,
        freeType: data?.caseInformations?.freeType?.valueObject?.id?.value
          ? {
              label: data?.caseInformations?.freeType?.valueObject?.name?.value,
              value: data?.caseInformations?.freeType?.valueObject?.id?.value,
            }
          : null,
        priceType: data?.caseInformations?.priceType?.valueObject?.id?.value
          ? {
              label:
                data?.caseInformations?.priceType?.valueObject?.name?.value,
              value: data?.caseInformations?.priceType?.valueObject?.id?.value,
            }
          : null,
        causeReason: data?.caseInformations?.causeReason?.valueObject?.id?.value
          ? {
              label:
                data?.caseInformations?.causeReason?.valueObject?.name?.value,
              value:
                data?.caseInformations?.causeReason?.valueObject?.id?.value,
            }
          : null,
        serviceReason: data?.caseInformations?.serviceReason?.valueObject?.id
          ?.value
          ? {
              label:
                data?.caseInformations?.serviceReason?.valueObject?.name?.value,
              value:
                data?.caseInformations?.serviceReason?.valueObject?.id?.value,
            }
          : null,
        protocolNo: data?.caseInformations?.protocolNo ?? null,
        labmedNo: data?.caseInformations?.labmedNo ?? null,
        memberNo: data?.caseInformations?.memberNo ?? null,
        memberContractNo: data?.caseInformations?.memberContractNo ?? null,
        memberFullname: data?.caseInformations?.memberFullname ?? null,
        triage: data?.caseInformations?.triage?.valueObject?.id?.value
          ? {
              label: data?.caseInformations?.triage?.valueObject?.name?.value,
              value: data?.caseInformations?.triage?.valueObject?.id?.value,
            }
          : null,
        userNote: data?.caseInformations?.userNote ?? null,
        complaint: data?.caseInformations?.complaint ?? null,
        institution: data?.caseInformations?.institution?.id
          ? {
              label: data?.caseInformations?.institution?.signboard,
              value: data?.caseInformations?.institution?.id,
            }
          : null,
        diagnoses:
          data?.caseInformations?.diagnoses?.map((item: any) => {
            return {
              id: item?.id,
              icdCodeId: item?.icdCode?.id,
              icdCodeName: item?.icdCode?.name,
              icdCode: item?.icdCode?.code,
              description: item?.description,
              savedType: item?.savedType,
            };
          }) ?? [],

        vitalSigns:
          data?.caseInformations?.vitalSigns?.map((item: any) => {
            return {
              id: item?.id,
              parameter: {
                label: item?.parameter?.valueObject?.name?.value,
                value: item?.parameter?.valueObject?.id?.value,
              },
              input1: item?.input1,
              input2: item?.input2,
              numberOfInput: item?.parameter?.valueObject?.numberOfInput?.value,
              unit: item?.parameter?.valueObject?.unit?.value,
            };
          }) ?? [],
          
        staff:data?.caseInformations?.staff?.id ?? null,
        supportStaff: data?.caseInformations?.supportStaff ?? null,
        department: data?.caseInformations?.department ?? null,
        supplier: data?.caseInformations?.supplier ?? null,
        time: data?.caseInformations?.time ?? null,
      },
      id: data?.id,
      caseType: data?.caseType,
      caseNo: data?.caseNo,
      createdAt: data?.createdAt ?? null,
      caseStatus: data?.caseStatus,
      appointmentStatus: data?.appointmentStatus,
      recordType: data?.recordType ?? null,
      uid: data?.uid ?? null,
      appointmentStartDate: data?.appointmentStartDate ?? null,
      appointmentEndDate: data?.appointmentEndDate ?? null,
      appointmentDuration: data?.appointmentDuration ?? null,
      cancelReason: data?.cancelReason?.valueObject?.id?.value ?? null,
      cancelDescription: data?.cancelDescription ?? null,
      isCaseApproved: data?.isCaseApproved ?? null,
      caseDate: data?.caseDate,
      plannedVehicle: data?.plannedVehicle ?? null,
      plannedStaff: data?.plannedStaff ?? null,
      childAppointments: data?.childAppointments ?? state.case.childAppointments ?? [],
      parentAppointment: data?.parentAppointment ?? state.case.parentAppointment ?? null,
      parentAppointmentId: data?.parentAppointmentId ?? state.case.parentAppointmentId ?? null,
    },
    loading: false,
    error: null,
  };
};
